<template>
    <div class="info-wrap py-5">
        <div class="container">
            <div class="row align-items-center mb-2 section-row">
        <div class="col-md-12">
          <img src="../../assets/images/décret 1.jpg" alt="Mission" class="section-img">
        </div>
        <div class="col-md-12">
          <img src="../../assets/images/décret 2.jpg" alt="Mission" class="section-img">
        </div>
        <div class="text-center mt-4">
            <a 
                href="/Decret.pdf"
                download="Decret.pdf"
                class="btn-download"
            >
                Télécharger décret
            </a>
        </div>
      </div>
        </div>
    </div>
</template>

<style scoped>
.info-wrap {
  background-color: #f8f9fa;
}

.section-row {
  padding: 20px 0;
}

.section-img {
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.section-img:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
}

.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 15px;
}

.section-text {
  font-size: 1rem;
  color: #6c757d;
  line-height: 1.7;
}

.btn-download {
  background-color: #ffc107;
  color: #0b1b3f;
  font-weight: 700;
  padding: 12px 25px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-download:hover {
  background-color: #e0a800;
  transform: translateY(-2px);
}


</style>
